<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Cf_Mg_Basket' | translate}}</h3></div>
  <div class="col-12 md:col-12">
    <p-tabView
      [controlClose]="true"
      (onChange)="handleChange($event)"
      (onClose)="closeTab($event)"
      [activeIndex]="index"
      >
      <p-tabPanel [header]="'List' | translate" [selected]="0 == index" [headerStyle]="{ 'font-weight': 'bold' }">
        <div class="grid">
          <div class="p-field-radiobutton col-3">
            <p-radioButton
              [disabled]="itemsSelected.length > 0"
              name="bskType"
              value="mail"
              [(ngModel)] = "bskType"
              (onClick)="onFilterClick('mail')"
              inputId="opt1"
            ></p-radioButton>
            <label for="opt1" class="ml-2">{{'Cfb_Mail' | translate}}</label>
          </div>
          <div class="p-field-radiobutton col-3">
            <p-radioButton
              [disabled]="itemsSelected.length > 0"
              name="bskType"
              value="coll"
              [(ngModel)] = "bskType"
              (onClick)="onFilterClick('coll')"
              inputId="opt2"
            ></p-radioButton>
            <label for="opt2" class="ml-2">{{'Cfb_Collect' | translate}}</label>
          </div>
          <div class="p-field-radiobutton col-3">
            <p-radioButton
              [disabled]="itemsSelected.length > 0"
              name="bskType"
              value="acti"
              [(ngModel)] = "bskType"
              (onClick)="onFilterClick('acti')"
              inputId="opt3"
            ></p-radioButton>
            <label for="opt3" class="ml-2">{{'Cfb_Action' | translate}}</label>
          </div>

          <div class="p-field-radiobutton col-3">
            <p-radioButton
              [disabled]="itemsSelected.length > 0"
              name="bskType"
              value="publ"
              [(ngModel)] = "bskType"
              (onClick)="onFilterClick('publ')"
              inputId="opt4"
            ></p-radioButton>
            <label for="opt4" class="ml-2">{{'Cfb_Publish' | translate}}</label>
          </div>
        </div>
        <p-table
          #dt
          [selectionMode]="'single'"
          [columns]="listColumns"
          [value]="dataList"
          [rows]="100"
          [paginator]="true"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          (onRowSelect)="showDetails($event)"
          (onFilter)="setFilteredList($event)"
          [sortField]="'name'"
          >
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'Tot' | translate}} {{ dataList.length }} {{'Cfb_Baskets' | translate}}</span>
            </span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th class="width-col-3">
                <i class="pi pi-copy" pTooltip="{{'Cf_Dup' | translate}}"></i>
              </th>
              <th [pSortableColumn]="columns[0].field" class="width-auto">
                <p-sortIcon [field]="columns[0].field"></p-sortIcon>{{columns[0].header}}
                <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                  style="color: darkgrey;">
              </th>
              <th [pSortableColumn]="columns[1].field" class="width-auto">
                <p-sortIcon [field]="columns[1].field"></p-sortIcon>{{columns[1].header}}
                <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[1].field, 'contains')"
                  style="color: darkgrey;">
              </th>
              <th [pSortableColumn]="columns[2].field" class="width-auto">
                <p-sortIcon [field]="columns[2].field"></p-sortIcon>{{columns[2].header}}
                <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[2].field, 'contains')"
                  style="color: darkgrey;">
              </th>
            </tr>
          </ng-template>
          <ng-template let-rowData let-columns="columns" pTemplate="body">
            <tr [pSelectableRow]="rowData">
              <td (click)="clickcolDup($event, rowData)">
                <i class="pi pi-copy"></i>
              </td>
              <td class="width-auto">
                {{ rowData[columns[0].field] }}
              </td>
              <td class="width-auto">
                {{ rowData[columns[1].field] }}
              </td>
              <td class="width-auto">
                {{ rowData[columns[2].field] }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">{{'Empty' | translate}}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
        @for (item of itemsSelected; track item; let i = $index) {
          <p-tabPanel
            header="{{ item._label }}"
            [selected]="i == index - 1"
            [closable]="true"
            >
            @if (item.id === -1) {
              <app-add-basket
                [groupList]="groupList"
                [userList]="userList"
                (onCancel)="cancelAdd($event)"
                (onValidate)="addTab($event)"
                >
              </app-add-basket>
            }
            @if (item.id !== -1) {
              <app-edit-basket
                [item]="item"
                [bskType]="bskType"
                [duplicate]="duplicate"
                [groupList]="groupList"
                [userList]="userList"
                [basketList]="dataList"
                (onCancel)="closeTab($event)"
                (onValidate)="validateTab($event)"
                (onDeleteItem)="confirmDelete($event)"
                (onLoadItem)="onLoadItem($event)"
                >
              </app-edit-basket>
            }
          </p-tabPanel>
        }
    </p-tabView>
  </div>
</div>
<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>